export default "__VITE_ASSET__HEYeBHU1__"